module.exports = __webpack_public_path__ + "img/tip_CRM.9f2a6699.png";